/**
 * Auth headers for raw PostgREST / Edge Function fetch() calls.
 *
 * Many Flow services talk to /rest/v1 with plain fetch() instead of the
 * supabase-js client, and historically hardcoded the anon key in the
 * Authorization header — so those requests ran as `anon` even for signed-in
 * users, and would return 401/empty once RLS is tightened to
 * authenticated+allowed users. This helper sends the current session's
 * access token (email or Microsoft-exchanged session alike) and falls back
 * to the anon key when no one is signed in.
 */

import { supabase } from '@/lib/supabase';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export async function restHeaders(
  extra?: Record<string, string>
): Promise<Record<string, string>> {
  let accessToken: string | undefined;
  try {
    const { data } = await supabase.auth.getSession();
    accessToken = data.session?.access_token;
  } catch (error) {
    console.warn('[supabaseRest] getSession failed, falling back to anon key:', error);
  }

  return {
    apikey: supabaseAnonKey,
    Authorization: `Bearer ${accessToken ?? supabaseAnonKey}`,
    'Content-Type': 'application/json',
    ...extra,
  };
}
